<template>
  <div class="m-pwd">
    <div class="navbar">
      <button class="back" @click="goBack">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"
             stroke-linejoin="round">
          <path d="M15 19l-7-7 7-7"/>
        </svg>
      </button>
      <h1>修改密码</h1></div>

    <div class="scroll pwd-body">
      <div class="fld" :class="{ err: errors.old }">
        <label>原密码 <em>*</em></label>
        <div class="in">
          <input type="password" v-model="form.old" placeholder="请输入当前登录密码">
        </div>
        <div class="msg">{{ errors.old }}</div>
      </div>
      <div class="fld" :class="{ err: errors.new }">
        <label>新密码 <em>*</em></label>
        <div class="in">
          <input type="password" v-model="form.new" placeholder="6-20 位，需包含字母和数字">
        </div>
        <div class="msg">{{ errors.new }}</div>
      </div>
      <div class="fld" :class="{ err: errors.confirm }">
        <label>确认新密码 <em>*</em></label>
        <div class="in">
          <input type="password" v-model="form.confirm" placeholder="请再次输入新密码">
        </div>
        <div class="msg">{{ errors.confirm }}</div>
      </div>
      <div class="tip">
        密码长度 6-20 位，必须同时包含字母与数字，不可与最近 3 次使用过的密码相同。修改成功后需使用新密码重新登录。
      </div>
      <button class="btn primary block" :disabled="loading" @click="handleSave">
        {{ loading ? '提交中...' : '确认修改' }}
      </button>
    </div>

  </div>
</template>

<script>
import mobileRem from '@/commonJs/mobileRem';
import ApiService from '@/service/ApiService';
import pub from '@/service/public';
import cookie from '@/service/cookie';
import md5 from 'js-md5';

export default {
  name: 'MPwd',
  mixins: [mobileRem],
  data() {
    return {
      form: {
        old: '',
        new: '',
        confirm: ''
      },
      errors: {
        old: '',
        new: '',
        confirm: ''
      },
      loading: false
    };
  },
  mounted() {
    // 初始化
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    handleSave() {
      this.errors.old = '';
      this.errors.new = '';
      this.errors.confirm = '';
      let ok = true;

      if (!this.form.old) {
        this.errors.old = '请输入原密码';
        ok = false;
      }

      if (!this.form.new) {
        this.errors.new = '请输入新密码';
        ok = false;
      } else if (this.form.new.length < 6 || this.form.new.length > 20) {
        this.errors.new = '密码长度需为 6-20 位';
        ok = false;
      } else if (this.form.new === this.form.old) {
        this.errors.new = '新密码不可与原密码相同';
        ok = false;
      }

      if (!this.form.confirm) {
        this.errors.confirm = '请再次输入新密码';
        ok = false;
      } else if (this.form.confirm !== this.form.new) {
        this.errors.confirm = '两次输入的新密码不一致';
        ok = false;
      }

      if (!ok) return;

      this.loading = true;
      // 与 PC AppHeader.handleConfirmChangePassword 传参一致，仅 agent 改为 mobile
      const accountStr = cookie.getCookie('28project_UsrInfo');
      const accountInfo = accountStr ? JSON.parse(accountStr) : {};
      const params = {
        page: {number: 0, limit: 1},
        keyWord: [],
        parms: {
          strClientUuid: 'A0F9GQHU6YE3D5AG',
          strUsrUuid: accountInfo.strUsrUUID,
          strUsrPwd: md5(this.form.old.trim()),
          strUsrName: this.$cookies.get('28project_username'),
          strUsrNewPwd: md5(this.form.new.trim())
        }
      };
      ApiService.UsrUpdPwd(params, 'mobile')
        .then(res => {
          if (res && res.code === pub.backCode.SUCCESS) {
            // 与 PC 一致：清空 token 与本地用户信息，保留用户名 cookie 以便下次自动填充
            pub.clearLoginState();
            cookie.removeCookie('28project_UsrInfo');
            this.$cookies.set('28project_userpwd', this.form.new);
            pub.tip('修改成功，请重新登录', 'success');
            setTimeout(() => {
              this.$router.push('/m/login');
            }, 1300);
          } else {
            this.errors.old = (res && (res.message || res.msg)) || '原密码不正确';
            if (res) pub.analysisReturnCode(res, null);
          }
        })
        .catch(error => {
          console.error('修改密码失败：', error);
          pub.tip('修改失败，请稍后重试', 'error', 1500);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    goLogin() {
      this.$router.push('/m/login');
    }
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent
}

.m-pwd {
  --primary: #12b3a8;
  --primary-d: #0d9b91;
  --primary-l: #e8f8f6;
  --danger: #f5544b;
  --danger-l: #ffeeed;
  --t1: #14181f;
  --t2: #5b6472;
  --t3: #9aa4b2;
  --line: #eef0f4;
  --bg: #f4f6f8;
  --card: #fff;
  font-size: 14px;
  line-height: normal;
  -webkit-text-size-adjust: 100%;
  min-height: 100vh;
  background: var(--bg);
  display: flex;
  flex-direction: column
}

.navbar {
  height: 46px;
  flex: none;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  border-bottom: .5px solid rgba(0, 0, 0, .15)
}

.navbar h1 {
  font-size: 17px;
  font-weight: 600;
  color: var(--t1)
}

.navbar .back {
  position: absolute;
  left: 4px;
  top: 0;
  height: 46px;
  width: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--t1);
  cursor: pointer;
  background: none;
  border: none
}

.navbar .back svg {
  width: 19px;
  height: 19px
}

.scroll {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch
}

.pwd-body {
  padding: 16px 14px
}

.fld {
  margin-bottom: 15px
}

.fld label {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 13px;
  color: var(--t2);
  margin-bottom: 7px;
  font-weight: 500
}

.fld label em {
  color: var(--danger);
  font-style: normal
}

.fld .in {
  position: relative;
  display: flex;
  align-items: center
}

.fld input {
  flex: 1;
  width: 100%;
  height: 46px;
  background: #fff;
  border-radius: 11px;
  padding: 0 13px;
  font-size: 15px;
  color: var(--t1);
  border: 1.5px solid #d9dee6;
  transition: .15s
}

.fld input:focus {
  border-color: var(--primary);
  background: #fff;
  box-shadow: 0 0 0 3px var(--primary-l)
}

.fld.err input {
  border-color: var(--danger);
  background: var(--danger-l)
}

.fld .msg {
  font-size: 12px;
  color: var(--danger);
  margin-top: 5px;
  display: none
}

.fld.err .msg {
  display: block
}

.tip {
  background: var(--primary-l);
  border-radius: 10px;
  padding: 11px 13px;
  font-size: 12.5px;
  color: var(--primary-d);
  line-height: 1.7;
  margin: 4px 0 20px;
  text-align: justify;
}

.btn {
  height: 31px;
  padding: 0 15px;
  border-radius: 16px;
  font-size: 13px;
  border: 1px solid #dfe3ea;
  color: var(--t2);
  background: #fff;
  transition: .12s
}

.btn:active {
  transform: scale(.96)
}

.btn.primary {
  background: var(--primary);
  border-color: var(--primary);
  color: #fff;
  font-weight: 600
}

.btn.block {
  width: 100%;
  height: 46px;
  border-radius: 23px;
  font-size: 16px;
  border: none
}

.btn:disabled {
  opacity: .6
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/MPwd.vue